module.exports = __webpack_public_path__ + "static/media/zheng2-3@3x.bf7537ac.png";